import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

// These trackers depend on nothing from the component, so they live at module
// scope: their identity is stable and they can safely be listed in hook
// dependency arrays without re-running effects on every render.
const trackEvent = (eventName, parameters = {}) => {
    if (analytics) {
        logEvent(analytics, eventName, parameters);
    }
};

// Common event tracking functions
const trackPageView = (pageName) => {
    trackEvent("page_view", {
        page_title: pageName,
        page_location: window.location.href,
    });
};

const trackLogin = (method = "email") => {
    trackEvent("login", {
        method: method,
    });
};

const trackSignUp = (method = "email") => {
    trackEvent("sign_up", {
        method: method,
    });
};

const trackSearch = (searchTerm) => {
    trackEvent("search", {
        search_term: searchTerm,
    });
};

const trackButtonClick = (buttonName, location) => {
    trackEvent("select_content", {
        content_type: "button",
        item_id: buttonName,
        content_id: location,
    });
};

const trackFeatureUsage = (featureName, action = "use") => {
    trackEvent("feature_usage", {
        feature_name: featureName,
        action: action,
    });
};

const trackUserEngagement = (engagementType, value) => {
    trackEvent("user_engagement", {
        engagement_type: engagementType,
        value: value,
    });
};

const analyticsApi = {
    trackEvent,
    trackPageView,
    trackLogin,
    trackSignUp,
    trackSearch,
    trackButtonClick,
    trackFeatureUsage,
    trackUserEngagement,
};

export const useAnalytics = () => analyticsApi;
